import { downloadCSV } from "react-admin";
import { get } from "lodash";
import jsonExport from "jsonexport/dist";
import moment from "moment";

const exporter = (users, translate) => {
  const columnName = (name) => translate(`resources.users.fields.${name}`);

  const dateFormat = translate("app.date_format.long");

  const usersToExport = users.map((user) => ({
    [columnName("id")]: get(user, "id"),
    [columnName("profile.name")]: get(user, "profile.name"),
    [columnName("profile.surname")]: get(user, "profile.surname"),
    [columnName("email")]: get(user, "email"),
    [columnName("created")]: moment(get(user, "created")).format(dateFormat),
    [columnName("last_login")]:
      get(user, "last_login") !== null
        ? moment(get(user, "last_login")).format(dateFormat)
        : "NA",
    [columnName("status")]: translate(
      `resources.users.status.${get(user, "status")}`
    ),
    [columnName("roles")]: get(user, "roles")
      .map((role) => get(role, "name"))
      .join(", "),
  }));
  jsonExport(
    usersToExport,
    {
      rowDelimiter: ";",
      headers: [
        columnName("id"),
        columnName("profile.name"),
        columnName("profile.surname"),
        columnName("email"),
        columnName("created"),
        columnName("last_login"),
        columnName("status"),
        columnName("roles"),
      ],
    },
    (err, csv) => downloadCSV("\uFEFF" + csv, "users")
  );
};

export default exporter;
